import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllKras, getSkillAndWllUserSpecific } from '../../../../../../redux/features/appraisalSlice';
import WillCard from './WillCard';
import { Box } from '@mui/material';
import PaginationComponent from '../../../../../appraisal/goalManagement/PaginationComponent';
import NoDataFound from '../../../../../../components/NodataIndication/NoDataFound';
import MotionWrapper from '../../../../../../components/MotionWrapper';
import LoadingSkeleton from '../../../golas/TeamGoals/LoadingSkelton';
import DeleteWill from './DeleteWill';
import TagWill from './TagWill';

const WillUserSpecific = ({ user, induvidualView }) => {
  const dispatch = useDispatch();
  const { skillAndWllUserSpecificData, loading } = useSelector((state) => state.appraisal);
  const [open, setOpen] = useState(false);
  const data = {
    type: 'will',
    userTypeId: '',
    userId: user?.userID || '',
  };

  const [selectedWill, setSelectedWill] = useState(null);
  const [dispatchNew, setDiapatchNew] = useState(false);

  const handleDeletePopup = (will) => {
    setSelectedWill(will);
    setOpen(true);
  };
  useEffect(() => {
    const data = { type: 'will', search: '' };
    dispatch(getAllKras(data));
  }, []);
  return (
    <Box>
      {!induvidualView && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', pb: 1 }}>
          <TagWill userId={user?.userID || ''} update={setDiapatchNew} />
        </Box>
      )}

      {loading ? (
        <LoadingSkeleton />
      ) : (
        <>
          {Array.isArray(skillAndWllUserSpecificData?.data) && skillAndWllUserSpecificData.data.length > 0 ? (
            skillAndWllUserSpecificData.data.map((item, i) => (
              <Box key={item.sl_no}>
                <MotionWrapper direction={'top'} delay={i * 0.1}>
                  <WillCard handleDeletePopup={handleDeletePopup} data={item}induvidualView={induvidualView} />
                </MotionWrapper>
              </Box>
            ))
          ) : (
            <NoDataFound />
          )}
        </>
      )}

      <Box>
        <Box pt={2}>
          <PaginationComponent
            api={getSkillAndWllUserSpecific}
            otherProps={data}
            loading={loading}
            dependencyFields={[dispatchNew]}
            meta={skillAndWllUserSpecificData.meta}
          />
        </Box>
      </Box>
      <DeleteWill open={open} setOpen={setOpen} skill={selectedWill} setDispatchNew={setDiapatchNew} />
    </Box>
  );
};

export default WillUserSpecific;
